import { KendoBaseComponent } from '@progress/kendo-base-components-vue-wrapper'
import WindowProps from './WindowProps'

import Animation from './Animation'
import Content from './Content'
import Draggable from './Draggable'
import Modal from './Modal'
import Position from './Position'
import Title from './Title'

export default {
    props: WindowProps,
    render (h) {
        return h('div',this.$slots.default)
    },
    mixins: [
        KendoBaseComponent,
        Animation,
        Content,
        Draggable,
        Modal,
        Position,
        Title
    ],
    mounted() {
        kendo.jQuery(this.$el).kendoWindow(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoWindow()
        },
        toggleClasses () {

        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-window-vue-wrapper/src/KendoWindow/KendoWindowMixin.js